import React from "react";
import { Label } from "reactstrap";
import Required from "./Required";

const MyCheck = ({ title, name, register, watch, trigger, errors, setValue, placeholder, required, disabled }) => {
  return (
    <div className="form-group my-2">
      <Label className="from-label" htmlFor={name}>
        {title}
        {required && <Required />}
      </Label>
      <div className="form-control-wrap ">
        <div className="d-flex justify-content-start">
          <input
            type="checkbox" // Use checkbox instead of type="check"
            id={name}
            {...register(name, {
              required: required && `${name} is required`,
            })}
            className="form-check my-1"
            checked={watch(name)} // Use 'checked' instead of 'value'
            onChange={(e) => {
              setValue(name, e.target.checked); // Set value to true/false
              trigger(name); // Trigger validation
            }}
            disabled={disabled} // Disable if passed as prop
          />
          <span htmlFor={name} className="mx-2 my-1">
            {placeholder}
          </span>
        </div>
        {errors[name] && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors[name]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyCheck;
